__turbopack_context__.v({
  "ButtonCopied": "Share-module-sass-module__EppG0a__ButtonCopied",
  "Copied": "Share-module-sass-module__EppG0a__Copied",
  "Share": "Share-module-sass-module__EppG0a__Share",
  "Visible": "Share-module-sass-module__EppG0a__Visible",
  "hideAgain": "Share-module-sass-module__EppG0a__hideAgain",
});
